import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {PosManagerRepository} from "@/modules/posManager/adapter/PosManagerRepository";
import {ServiceClient} from "@/modules/shared/ServiceCall";
import moment from "moment-mini";

const TIMEOUT_MESSAGE = 'Es ist leider zu einer Zeitüberschreitung gekommen.\n'
    + 'Grund dafür kann eine zu große Datenmenge sein.';

export class PosManagerRestRepository implements PosManagerRepository {
    private readonly auth: AuthenticationProvider;
    private readonly service: ServiceClient;

    constructor(auth: AuthenticationProvider) {
        this.auth = auth;
        // nicht als Feld-Initializer: this.auth ist zu dem Zeitpunkt noch undefined
        this.service = new ServiceClient(auth, 'POSManager');
    }

    private salesList = [ {
            "LABEL" : "Auswertungen",
            "ICON" : "posmanager-presentation-business",
            "GRIDNAME" : "",
            "FORMNAME" : "",
            "DISABLED" : false
          },
            {
                "LABEL" : "Bons",
                "ICON" : "posmanager-bill-credit-card",
                "GRIDNAME" : "",
                "FORMNAME" : "",
                "DISABLED" : false
            },
            {
                "LABEL" : "Kassenberichte",
                "ICON" : "posmanager-cash-register",
                "GRIDNAME" : "",
                "FORMNAME" : "",
                "DISABLED" : false
            }];

    public async bestandsmeldungen_process_Scandata(code:string, method:number):Promise<any> {
        return this.service.call<any>('Bestandsmeldungen_process_Scandata', {
            Content: code.trim(),
            Mode: method == 0 ? "add" : "subtract",
        });
    }

    public async get_task_status():Promise<any[]> {
        // Filiale und TaskIDs waren hier schon vor der Migration auskommentiert
        const result = await this.service.call<{ Tasks: any[] }>('get_task_status');
        return result.Tasks;
    }

    public async start_Bestandsaktualisierung(): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'start_Bestandsaktualisierung', {}, { withBranchId: true });
        return result.TaskID;
    }

    public async receiveFinancialReports(): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>('receive_FinancialReports');
        return result.TaskID;
    }

    public async receiveTaf(): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'receive_TAF', {}, { withBranchId: true });
        return result.TaskID;
    }

    public async receivePersonalzeiten(): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'receive_Personalzeiten', {}, { withBranchId: true });
        return result.TaskID;
    }

    public async sendMCustomers(mode: number): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'send_Kunden', { Mode: mode }, { withBranchId: true });
        return result.TaskID;
    }

    public async sendScaleData(mode: number): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'send_Kassendaten', { Mode: mode }, { withBranchId: true });
        return result.TaskID;
    }

    public async sendMasterdata(mode: number): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'send_Stammdaten', { Mode: mode }, { withBranchId: true });
        return result.TaskID;
    }

    public async sendArticle(mode: number): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'send_Artikel', { Mode: mode }, { withBranchId: true });
        return result.TaskID;
    }

    public async sendArticleList(selected:{RecordId:number}[]): Promise<string> {
        const result = await this.service.call<{ TaskID: string }>(
            'send_ArtikelList', { Selected: selected }, { withBranchId: true });
        return result.TaskID;
    }

    public async isTransmitting(): Promise<boolean> {
        return await this.getConnectionStatus() !== 1;
    }

    public async getConnectionStatus(): Promise<number> {
        // nicht verbunden=0,
        // inaktiv=1,
        // aktiv=2,
        // Connect-Dienst nicht bereit=3
        const result = await this.service.call<{ status?: number }>(
            'get_connection_status', {}, { withUserId: true, withBranchId: true });
        // `?.` wie bisher: fehlt der Envelope, kommt undefined zurück statt eines Fehlers
        return result?.status as number;
    }

    public async getReports(reportTyp:number): Promise<any[]> {
        //https://portal.aprocon.de:44380/POSManager?get_POSManagerReports
        const result = await this.service.call<{ POSManReports?: any[] }>(
            'get_POSManagerReports', { Reporttyp: reportTyp },
            { withUserId: true, withBranchId: true });
        return result?.POSManReports as any[];
    }

    public async getReport(args: { reportNr: number, start: Date|undefined, end: Date|undefined , choice:number|undefined}): Promise<string> {
        const result = await this.service.call<{ ImageURL: string }>('get_URL_POSManagerReport', {
            ReportNr: args.reportNr,
            DatumVon: args.start ? moment(args.start).format("YYYY/MM/DD") : undefined,
            DatumBis: args.end ? moment(args.end).format("YYYY/MM/DD") : undefined,
            Auswahl: args.choice,
        }, {
            withBranchId: true,
            timeoutMs: 120000,
            timeoutMessage: TIMEOUT_MESSAGE,
        });
        return result.ImageURL;
    }

    public getSalesGridList(): any[] {
        const sid = this.auth.getAuthToken();

        if (sid) {
            const tabs: any[] = [];
            const apiTabs = this.salesList;
            for (let i = 0; i < apiTabs.length; i++) {
                tabs.push({
                    id: i,
                    route: `/umsaetze/${i}`,
                    name: apiTabs[i].LABEL,
                    icon: apiTabs[i].ICON,
                    gridName: apiTabs[i].GRIDNAME,
                    formName: apiTabs[i].FORMNAME,
                })
            }

            return tabs;
            // const response = await axios.post(`${this.auth.getServiceUrl()}/Stammdaten/Stammdaten_GetGridList`, {
            //     SID: sid,
            //     UserId: user
            // });
            // if (response.data.Stammdaten_GetGridList_response?.ServiceErrors) {
            //     throw new Error(response.data.Stammdaten_GetGridList_response.ServiceErrors[0].ERRORRECOMMENDATION);
            // } else {
            //     const tabs = new Array();
            //     const apiTabs = response.data.Stammdaten_GetGridList_response;
            //     for (let i = 0; i < apiTabs.length; i++) {
            //         tabs.push({
            //             id: i,
            //             route: `/stammdaten/${i}`,
            //             name: apiTabs[i].LABEL,
            //             icon: apiTabs[i].ICON,
            //             gridName: apiTabs[i].GRIDNAME,
            //             formName: apiTabs[i].FORMNAME,
            //         })
            //     }
            //
            //     return tabs;
        }
        return [];
    }

    public async getCashReport(date:string, id=-1): Promise<string> {
        const result = await this.service.call<{ ImageURL: string }>(
            'get_URL_POSManagerKassenbericht', {
                Datum: date,
                KassenberichtRecordID: id,
                // Achtung: hier `UserId` mit kleinem d — nicht `UserID` wie bei
                // get_connection_status. Deshalb explizit statt über withUserId.
                UserId: this.auth.getUserId(),
            }, {
                withBranchId: true,
                timeoutMessage: TIMEOUT_MESSAGE,
            });
        return result.ImageURL;
    }

    public async getBonReport(id=-1): Promise<string> {
        const result = await this.service.call<{ ImageURL: string }>(
            'get_URL_POSManagerBon', {
                UserId: this.auth.getUserId(),
                BonID: id,
            }, {
                timeoutMessage: TIMEOUT_MESSAGE,
            });
        return result.ImageURL;
    }
}
